"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var v1_1 = require("./v1");
var GraphRest = /** @class */ (function () {
    function GraphRest() {
    }
    Object.defineProperty(GraphRest.prototype, "v1", {
        get: function () {
            return new v1_1.V1("");
        },
        enumerable: true,
        configurable: true
    });
    return GraphRest;
}());
exports.GraphRest = GraphRest;



//////////////////
// WEBPACK FOOTER
// ./lib/graph/rest.js
// module id = 57
// module chunks = 0